import React from "react";
import {Search} from "@mui/icons-material";
import * as Icons from "@mui/icons-material";
import CustomIcon from "./CustomIcon";
import CustomDialog from "./CustomDialog";
import {useTranslation} from "react-i18next";

export interface CustomSelectProps {
    value?: any;
    setValue?: any;
    label?: string;
    disabled?: boolean;
    fontSize?: string;
}

export default function CustomSelectIcons({
                          value,
                          setValue,
                          label,
                          disabled,
                          fontSize,
                      }: CustomSelectProps) {
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const iconNames = Object.keys(Icons) as Array<keyof typeof Icons>;
    const [open, setOpen] = React.useState(false);

    return (
        <>
            {open && <CustomDialog
                size={'xl'}
                title={label}
                body={
                    <div className={'grid grid-cols-5 gap-3'}>
                        {iconNames.map((iconName: string) => {
                            return (
                                <div
                                    className={'flex flex-row gap-3 z-50 cursor-pointer truncate'}
                                    key={iconName}
                                    onClick={() => {
                                        setValue(iconName);
                                        setOpen(false)
                                    }}
                                >
                                    <CustomIcon iconName={iconName}/>
                                    <div>{iconName}</div>
                                </div>
                            );
                        })}
                    </div>
                }
                {...{open, setOpen}}
            />}
            <div
                className={`custom-select flex flex-col w-full cursor-pointer ${disabled ? 'pointer-events-none' : ''}`}>
                <div className={'label labelCustom'}>
                <span
                    className={
                        `${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] bg-white ml-[18px] px-1 rounded-[5px]`
                    }
                >
                    {label}
                </span>
                </div>
                <div className={'select-modal'}>
                    <div
                        className={`styleInput text-input !border !border-inputBorder flex min-h-[40px] max-h-[40px] rounded-[4px] 
                                shadow-lg shadow-gray-900/5 ring-1 ring-transparent placeholder:text-gray-500 focus:!border-primary`}
                        style={{fontSize: `${fontSize ? fontSize : '$sizeText'}`}} onClick={() => {
                        setOpen(true)
                    }}
                    >
                        <div
                            className={`w-[80%] px-3 text-base mt-[9px] truncate flex flex-row gap-3`}>
                            {value !== null && value !== undefined ?
                                <>
                                    <CustomIcon iconName={value}/>
                                    <div className={'truncate'}>{value}</div>
                                </> : <>{t('select')}</>
                            }
                        </div>
                        <div className={'w-[20%] text-right'}>
                            {<Search
                                className={`${disabled ? 'text-colorDisabled' : 'text-inputBorder'} mr-2 mt-[7px] w-[27px] min-w-[27px] max-w-[27px]`}
                                onClick={() => {
                                    setOpen(true)
                                }}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
